<td class="table-body-cell" *ngIf="cell && !cell.buttons && !cell.links" [attr.colspan]="colspan" [attr.title]="cell.label">
  <sp-icon class="table-body-cell-icon currentcolor" *ngIf="cell.icon" [name]="cell.icon" type="solid" size="small"></sp-icon>
  {{ cell.title }}
  <ng-template ngFor let-tag [ngForOf]="cell.tags">
    <sp-tag [type]="tag.type" [style]="tag.style" [link]="tag.link" [removeable]="tag.removeable" (OnClickEvent)="tag.OnClickEvent()">
      {{ tag.label }}
    </sp-tag>
  </ng-template>
</td>
<td class="table-body-cell --pull-end --actions" *ngIf="cell && cell.buttons && !buttons" [attr.colspan]="colspan">
  <sp-button
    class="table-body-cell-button"
    *ngFor="let button of cell.buttons"
    size="small"
    [icon]="button.icon"
    [style]="'no-label ghost icon --currentColor'"
    (clickAction)="button.action(row)"
  ></sp-button>
  <img
    *ngIf="expandableTable"
    [class.table-body-cell-arrow-expandable-open]="expanded"
    class="table-body-cell-arrow-expandable"
    src="/public/resources/images/icons/dropdown-arrow-down.svg"
  />
</td>
<td class="table-body-cell" *ngIf="cell && cell.links" [attr.colspan]="colspan">
  <ul>
    <li *ngFor="let link of cell.links">
      <a (click)="link.action(row)">{{ link.name }}</a>
    </li>
  </ul>
</td>
<td class="table-body-cell" *ngIf="!cell" [attr.colspan]="colspan" [attr.title]="label" [class.main-label]="main">
  <ng-content></ng-content>
</td>
